import { render, staticRenderFns } from "./LongQuestion.vue?vue&type=template&id=66bb242e&scoped=true&"
import script from "./LongQuestion.vue?vue&type=script&lang=ts&"
export * from "./LongQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./LongQuestion.vue?vue&type=style&index=0&id=66bb242e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bb242e",
  null
  
)

export default component.exports